/**
 * Created by denis.gusarov on 4/27/2017.
 */

namespace Factive.Game {
    import Tween = Factive.Core.Tween.Tween;
    import Easing = Factive.Core.Tween.Easing;

    export class IRollButtonOptions {
        onPress:Function
    }

    export class RollButtonView extends ViewBase {

        public $model: any = {};

        public get onPress(): Function {
            return this._options.onPress;
        }

        public set onPress(value: Function) {
            this._options.onPress = value;
        }

        public constructor(private _options: IRollButtonOptions) {
            super();
        }

        public static factory: any = {
            get (opt): RollButtonView {
                return new RollButtonView(opt);
            },
            dependency: ["Options"]
        };

        public getConfiguration(): IViewConfiguration {
            return <IViewConfiguration>{
                armatureName: "RollButton",
                sprites: {
                    hitArea: "armature(hitArea)"
                },
                spritesEvents: {
                    "touchstart $sprites.hitArea": "_onMouseOver",
                    "tap $sprites.hitArea": "_onMouseClickOrTap",
                    "touchendoutside $sprites.hitArea": "_onMouseOut",
                    "mouseover $sprites.hitArea": "_onMouseOver",
                    "mouseout $sprites.hitArea": "_onMouseOut",
                    "click $sprites.hitArea": "_onMouseClickOrTap"
                },
                animations: {
                    outAnimation: "OutAnimation",
                    overAnimation: "OverAnimation"
                },
                animationsEvents: {
                    // "frameEvent $animations.press": "frameEvent",
                    // "complete $animations.press": "animtionPressComplete"
                },
                childViews: {
                    labelView: {
                        view: "LabelView",
                        //x: 0,
                        y: 0,
                        options: {
                            text: "Roll",
                            fontSize: 30,
                            fontFamily: 'MLBArialNarrow',
                            fill: '#ffffff',
                            align: 'left',
                            wordWrap : true,
                            wordWrapWidth : 200
                        }
                    }
                }
            };
        }

        protected onContentLoaded(){
        }

        protected onSetLandscape(){
        }

        protected onSetPortrait(){
        }

        public onInitialize(): void {
        }

        private _onMouseOver(event: PIXI.interaction.InteractionEvent): void {
            this.$animations.get("overAnimation").play();
        }

        private _onMouseOut(event: PIXI.interaction.InteractionEvent): void {
            this.$animations.get("outAnimation").play();
        }

        private _onMouseClickOrTap(event: PIXI.interaction.InteractionEvent): void {
            if(this._options.onPress){
                this._options.onPress();
            }
        }
    }

}


// WEBPACK FOOTER //
// src/typescript/Game/Views/Game/RollButtonView.ts